export const RECOVERY_KEY = 'gf:recovery_session';

export function setRecoveryFlag() {
  try { 
    localStorage.setItem(RECOVERY_KEY, '1'); 
  } catch {}
}

export function clearRecoveryFlag() {
  try { 
    localStorage.removeItem(RECOVERY_KEY); 
  } catch {}
}

export function isRecoveryFlagSet() {
  try { 
    return localStorage.getItem(RECOVERY_KEY) === '1'; 
  } catch { 
    return false; 
  }
}